import React, { Component } from 'react'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import requester from '../../lib/requester'
import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'
import moment from 'moment'
import _ from 'lodash'
import ReactExport from "react-export-excel-hot-fix"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import Modal from '../../component/modal';

class ReportBalanceClaimDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      isLoading: false
    }
  }

  componentDidMount = () => {
    this.handleSearch()
  }

  handleSearch = () => {
    let url = '/api/traces/v1/collection/report-balance-detail'
    let { id } = this.props.match.params;
    let param = {
      claim_id: id
    }
    requester.postTraces(url, param, {
      success: function(response) {
        let { data } = response.data
        this.setState({ dataTable: data })
      }.bind(this),
      error: function(e) {
        console.log(e)
      }.bind(this)
    })
  }
  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "Claim Number",
          accessor: "claim_number",
        },
        {
          Header: "Invoice Number",
          accessor: "invoice_number",
        },
        {
          Header: "Invoice Date",
          accessor: "invoice_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "Amount Applied",
          accessor: "invoice_amount",
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "Coll Match ID",
          accessor: "coll_match_id",
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
      />
    );
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-4 mt-3">
                        <button className="btn btn-warning btn-block" onClick={() => { this.props.history.push('/admin/reportprogram/balance') }}>Back</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Loader fullPage loading={this.state.isLoading} />
      </div>
    )
  }
}

export default ReportBalanceClaimDetail